import { useTranslation } from 'react-i18next'
import { Button } from 'ui/button'
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from 'ui/drawer'

type Props = {
  onClose: () => void
  onEndTour: () => void
  onKeepExploring: () => void
  open: boolean
}

export const TourFinishConfirmDrawer = ({ onClose, onEndTour, onKeepExploring, open }: Props) => {
  const { t } = useTranslation('onboarding')

  return (
    <Drawer
      onOpenChange={nextOpen => {
        if (!nextOpen) onClose()
      }}
      open={open}
    >
      <DrawerContent>
        <div className="mx-auto w-full max-w-sm">
          <DrawerHeader>
            <DrawerTitle>{t('End tour?')}</DrawerTitle>
            <DrawerDescription>{t('You can explore on your own')}</DrawerDescription>
          </DrawerHeader>
          <DrawerFooter className="p-4">
            <Button onClick={onEndTour}>{t('End tour')}</Button>
            <DrawerClose
              render={
                <Button onClick={onKeepExploring} variant="outline">
                  {t('Keep exploring')}
                </Button>
              }
            />
          </DrawerFooter>
        </div>
      </DrawerContent>
    </Drawer>
  )
}
